import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

import { getCollectionVariants, getCollectionList } from '../../actions/productAction';
import { Banner, Content } from '../Assets';
import { ASSET_IMAGE, RESOURCE_URL } from '../../config'

class NeverTooLavishPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this._getCollectionList();
  }

  async _getCollectionList() {
    const result = await this.props.getCollectionList({params: {name: 'never too lavish'  }});
    const { data } = result.value.data;
    if (data.length) {
      const _idCollection = data[0].id;
      this.props.getCollectionVariants(_idCollection, {params: {availables: true }});
    }
  }

  render() {
    return (
      <Container fluid className="main-container" id="home-container">
        <Banner
          src={`${ASSET_IMAGE}/sliders/banner-never-too-lavish.jpg`}
          alt={`${RESOURCE_URL}/sliders/banner-never-too-lavish.jpg`}
        />
        <Content />
      </Container>
    );
  }
}

const mapStateProps = state => ({
  dataProduct:state.dataProduct.products,
})

const mapDispatchToProps = dispatch => ({
  getCollectionVariants: (idCollection) => dispatch(getCollectionVariants(idCollection)),
  getCollectionList: (params) => dispatch(getCollectionList(params))
})

export default connect(mapStateProps, mapDispatchToProps)(NeverTooLavishPage);
